import React, { useState, useEffect } from "react";
import {
    Box, Typography, Switch, Button, IconButton,
    FormControlLabel, FormGroup, FormLabel, Modal, Tooltip,
    Container, Paper, Grid, Dialog, DialogActions, DialogContent, DialogTitle,
    FormControl, Snackbar, CircularProgress, Stack, Radio, RadioGroup
} from '@mui/material';
import MuiAlert from '@mui/material/Alert';
import EditIcon from '@mui/icons-material/Edit';

import { Info as InfoIcon } from '@mui/icons-material';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import dayjs from 'dayjs';
import { LocalizationProvider, TimePicker } from '@mui/x-date-pickers';
import useAxiosPrivate from "../utils/useAxiosPrivate";
import i18n from "../translationUtils/i18n";

const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    height: '80%',
    minWidth: '40%',
    overflow: 'scroll',
    overflowX: "hidden",
    bgcolor: 'background.paper',
    border: '2px solid #000',
    boxShadow: 24,
    p: 4,
};

const widthStyle = { width: "fit-content" };

export default function EditSettings({ user, onUpdateUser, onClose }) {
    const [editedUser, setEditedUser] = useState(user);
    const [open, setOpen] = useState(false);
    const [snackbarOpen, setSnackbarOpen] = useState(false);
    const [loading, setLoading] = useState(false);

    const [notificationId, setNotificationId] = useState(null);
    const [userId, setUserId] = useState(null);
    const [pressureOn, setPressureOn] = useState(false);
    const [sprayOn, setSprayOn] = useState(false);
    const [hotWorksAlerts, setHotWorks] = useState(false);
    const [waterOn, setWaterOn] = useState(false);
    const [eButtonOn, setEButtonOn] = useState(false);
    const [eCareOn, setECareOn] = useState(false);
    const [weekdayValue, setWeekdayValue] = useState('off');
    const [weekdaysOn, setWeekdaysOn] = useState(false);
    const [weekdayScheduleOn, setWeekdayScheduleOn] = useState(false);
    const [weekendValue, setWeekendValue] = useState('off');
    const [weekendsOn, setWeekendsOn] = useState(false);
    const [weekendScheduleOn, setWeekendScheduleOn] = useState(false);
    const [weekdaysStartTime, setWeekDaysStartTime] = useState(null);
    const [weekdaysEndTime, setWeekDaysEndTime] = useState(null);
    const [weekendsStartTime, setWeekEndsStartTime] = useState(null);
    const [weekendsEndTime, setWeekEndsEndTime] = useState(null);
    const [weekdayNotificationMode, setWeekdayNotificationMode] = useState("accumulation");
    const [weekendNotificationMode, setWeekendNotificationMode] = useState("accumulation");
    const [name, setName] = useState("");
    const [cellPhone, setCellPhone] = useState("");
    const [email, setEmail] = useState("");
    const [preferredLanguage, setPreferredLanguage] = useState("1");
    const [infoModalVisible, setInfoModalVisible] = useState(false);
    const [smsOn, setSMSOn] = useState(false);
    const [pushNotificationsOn, setPushNotificationsOn] = useState(false);
    const [emailsOn, setEmailsOn] = useState(false);

    const axiosPrivate = useAxiosPrivate();

    const handleOpen = () => setOpen(true);
    const handleClose = () => setOpen(false);
    const handleSnackbarClose = () => setSnackbarOpen(false);

    const handleSave = () => {
        //setLoading(true);
        setEditedUser(editedUser)

        const notifSettings = {
            notificationId: notificationId,
            userId: userId,
            pressureOn: pressureOn,
            sprayOn: sprayOn,
            hotWorksAlerts: hotWorksAlerts,
            waterOn: waterOn,
            eButton: eButtonOn,
            eCare: eCareOn,
            sms: smsOn,
            pushNotification: pushNotificationsOn,
            emailNotification: emailsOn,
            weekdayNotificationMode: weekdayNotificationMode,
            weekendNotificationMode: weekendNotificationMode,
            fullName: name,
            cellPhone: cellPhone.substring(cellPhone.indexOf(' ') + 1),
            email: email,
            countryCode: cellPhone.substring(0, cellPhone.indexOf(' ')),
            prefferedLanguage: preferredLanguage,
            weekdays: weekdaysOn,
            weekEnds: weekendsOn,
            weekdaySchedule: weekdayScheduleOn,
            weekEndSchedule: weekendScheduleOn,
            weekdayStartTime: weekdaysStartTime && dayjs(weekdaysStartTime).isValid() ? new Date(weekdaysStartTime).toLocaleTimeString('en-US', { hour12: false }) : null,
            weekdayEndTime: weekdaysEndTime && dayjs(weekdaysEndTime).isValid() ? new Date(weekdaysEndTime).toLocaleTimeString('en-US', { hour12: false }) : null,
            weekendStartTime: weekendsStartTime && dayjs(weekendsStartTime).isValid() ? new Date(weekendsStartTime).toLocaleTimeString('en-US', { hour12: false }) : null,
            weekendEndTime: weekendsEndTime && dayjs(weekendsEndTime).isValid() ? new Date(weekendsEndTime).toLocaleTimeString('en-US', { hour12: false }) : null
          };
      
          axiosPrivate.post("/api/NotificationSettings/saveNotificationSettings", notifSettings)
            .then(() => {
              handleClose();
              setSnackbarOpen(true);
            })
            .catch((error) => {
              console.error(error);
              alert("Error saving settings. Please try again.");
            })
            .finally(() => {
              setLoading(false);
            })
    };

    const loadData = (settings) => {
        setNotificationId(settings.notificationId);
        setUserId(settings.userId);
        setPressureOn(settings.pressureOn);
        setSprayOn(settings.sprayOn);
        setHotWorks(settings.hotWorksAlerts);
        setWaterOn(settings.waterOn);
        setEButtonOn(settings.eButtonOn);
        setECareOn(settings.eCare);
        setSMSOn(settings.sms);
        setPushNotificationsOn(settings.pushNotification);
        setEmailsOn(settings.emailNotification);
        setWeekdayNotificationMode(settings.weekdayNotificationMode ?? "accumulation");
        setWeekendNotificationMode(settings.weekendNotificationMode ?? "accumulation");
        setName(settings.fullName);
        setCellPhone(settings.countryCode + " " + settings.cellPhone);
        setEmail(settings.email);
        setPreferredLanguage(settings.prefferedLanguage);
        setWeekdayValue(handleLoadChange(settings.weekdays, settings.weekdaySchedule, settings.weekdayNotificationMode ?? "accumulation"));
        setWeekendValue(handleLoadChange(settings.weekends, settings.weekendSchedule, settings.weekendNotificationMode ?? "accumulation"));
        setWeekdaysOn(settings.weekdays);
        setWeekendsOn(settings.weekends);
        setWeekdayScheduleOn(settings.weekdaySchedule);
        setWeekendScheduleOn(settings.weekendSchedule);
        setWeekDaysStartTime(dayjs(`2023-01-01T${settings.weekdayStartTime}`));
        setWeekDaysEndTime(dayjs(`2023-01-01T${settings.weekdayEndTime}`));
        setWeekEndsStartTime(dayjs(`2023-01-01T${settings.weekendStartTime}`));
        setWeekEndsEndTime(dayjs(`2023-01-01T${settings.weekendEndTime}`));
    }

    useEffect(() => {
        loadData(user);
        // eslint-disable-next-line 
    }, []);

    const handleSms = (sms) => {
        if (sms && !smsOn) {
            alert(`${i18n.t('smsenabled')}: ${i18n.t('messageratesmayapply')}`);
        }
        setSMSOn(!smsOn);
    }

    const handlePreAction = () => {
        setPressureOn(!pressureOn);
        setWaterOn(!waterOn);
    };

    const handleWeekdayChange = (event) => {
        let selected = event.target.value;
        setWeekdayValue(selected);
        if (selected === 'on24/7') {
          setWeekdaysOn(true);
          setWeekdayScheduleOn(false);
        } else if (selected === 'off') {
          setWeekdaysOn(false);
          setWeekdayScheduleOn(false);
        } else if (selected === 'accumulation') {
          setWeekdaysOn(true);
          setWeekdayScheduleOn(true);
          setWeekdayNotificationMode('accumulation');
        } else if (selected === 'startStop') {
          setWeekdaysOn(true);
          setWeekdayScheduleOn(true);
          setWeekdayNotificationMode('startStop');
        }
      };
    
      const handleWeekendChange = (event) => {
        let selected = event.target.value;
        setWeekendValue(selected);
        if (selected === 'on24/7') {
          setWeekendsOn(true);
          setWeekendScheduleOn(false);
        } else if (selected === 'off') {
          setWeekendsOn(false);
          setWeekendScheduleOn(false);
        } else if (selected === 'accumulation') {
          setWeekendsOn(true);
          setWeekendScheduleOn(true);
          setWeekendNotificationMode('accumulation');
        } else if (selected === 'startStop') {
          setWeekendsOn(true);
          setWeekendScheduleOn(true);
          setWeekendNotificationMode('startStop');
        }
      };
    
      const handleLoadChange = (days, schedule, mode) => {
        if (days && !schedule) {
          return 'on24/7'
        } else if (days && schedule && mode === 'accumulation') {
          return 'accumulation'
        } else if (days && schedule && mode === 'startStop') {
          return 'startStop'
        } else {
          return 'off'
        }
      }

    return (
        <>
            <Tooltip title={i18n.t('editusersettings')}> 
                <IconButton aria-label="edit" onClick={handleOpen} color="primary">
                    <EditIcon />
                </IconButton>
            </Tooltip>
            <Modal
                open={open}
                onClose={handleClose}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
            >
                <Box sx={style}>
                    <Button variant="outlined" onClick={handleClose} style={{ position: 'absolute', top: '10px', right: '10px' }} disabled={loading}>X</Button>

                    <Typography variant="h6" component="h2" style={{ paddingBottom: "20px" }}>
                        {i18n.t('editusersettings')}
                    </Typography>

                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                        <Container>
                            <Paper elevation={3} sx={{ padding: 3, marginBottom: 3 }}>
                                <Typography variant="h6" paddingLeft={3} gutterBottom>{i18n.t('alertsiwanttoreceive')}</Typography>
                                <FormGroup>
                                <FormControlLabel
                                    control={<Switch checked={pressureOn && waterOn} onChange={handlePreAction} />}
                                    label={i18n.t('verifiedfire')}
                                    style={widthStyle}
                                />
                                <FormControlLabel
                                    control={<Switch checked={sprayOn} onChange={() => setSprayOn(!sprayOn)} />}
                                    label={i18n.t('suppressionactivated')}
                                    style={widthStyle}
                                />
                                <FormControlLabel
                                    control={<Switch checked={hotWorksAlerts} onChange={() => setHotWorks(!hotWorksAlerts)} />}
                                    label={i18n.t('mobilesuppressionunit')}
                                    style={widthStyle}
                                />
                                </FormGroup>
                            </Paper>

                            <Paper elevation={3} sx={{ padding: 3, marginBottom: 3 }}>
                                <Typography variant="h6" paddingLeft={3} gutterBottom>{i18n.t('alertdeliverymethods')}</Typography>
                                <FormGroup>
                                <FormControlLabel
                                    control={<Switch checked={smsOn} onChange={handleSms} />}
                                    label="SMS"
                                    style={widthStyle}
                                />
                                <FormControlLabel
                                    control={<Switch checked={pushNotificationsOn} onChange={() => setPushNotificationsOn(!pushNotificationsOn)} />}
                                    label={i18n.t('fireroverappnotifications')}
                                    style={widthStyle}
                                />
                                <FormControlLabel
                                    control={<Switch checked={emailsOn} onChange={() => setEmailsOn(!emailsOn)} />}
                                    label={i18n.t('emailnotifications')}
                                    style={widthStyle}
                                />
                                </FormGroup>
                            </Paper>

                            <Paper elevation={3} sx={{ padding: 3, marginBottom: 3 }}>
                                <Stack direction="row">
                                <Typography variant="h6" paddingLeft={3} gutterBottom>{i18n.t('wheniwanttoreceivealerts')}</Typography>
                                <IconButton onClick={() => setInfoModalVisible(true)} sx={{ padding: "0px 4px 0px 4px", marginBottom: "8px", marginLeft: "4px" }}>
                                    <InfoIcon />
                                </IconButton>
                                </Stack>

                                <Stack padding={2}>
                                <FormControl>
                                    <FormLabel id="weekdays-controlled-radio-buttons-group">{i18n.t('weekdays')}</FormLabel>
                                    <RadioGroup
                                    aria-labelledby="weekdays-controlled-radio-buttons-group"
                                    name="controlled-radio-buttons-group"
                                    value={weekdayValue}
                                    onChange={handleWeekdayChange}
                                    >
                                    <FormControlLabel value="on24/7" control={<Radio />} label={i18n.t('on247')} />
                                    <FormControlLabel value="off" control={<Radio />} label={i18n.t('off')} />
                                    <FormControlLabel value="accumulation" control={<Radio />} label={`${i18n.t('onperschedule')}: ${i18n.t('accumulation')} — ${i18n.t('accumulationinfo')}`} />
                                    <FormControlLabel value="startStop" control={<Radio />} label={`${i18n.t('onperschedule')}: ${i18n.t('startstop')} — ${i18n.t('startstopinfo')}`} />
                                    </RadioGroup>
                                </FormControl>
                                </Stack>
                                <Grid container direction="column" spacing={1}>
                                {weekdaysOn && weekdayScheduleOn && (
                                    <>
                                    <Grid item container spacing={2} alignItems="center" sx={{ paddingTop: "10px", paddingBottom: "5px" }}>
                                        <Grid item>
                                        <Typography>{i18n.t('starttime')}:</Typography>
                                        </Grid>
                                        <Grid item>
                                        <TimePicker label={i18n.t('starttime')} value={weekdaysStartTime} onChange={setWeekDaysStartTime} />
                                        </Grid>
                                    </Grid>

                                    <Grid item container spacing={2} alignItems="center">
                                        <Grid item>
                                        <Typography>{i18n.t('endtime')}:</Typography>
                                        </Grid>
                                        <Grid item style={{ paddingLeft: "21px", paddingBottom: "10px" }}>
                                        <TimePicker label={i18n.t('endtime')} value={weekdaysEndTime} onChange={setWeekDaysEndTime} />
                                        </Grid>
                                    </Grid>
                                    </>
                                )}

                                <Stack paddingLeft={3}>  
                                    <FormControl>
                                    <FormLabel id="weekends-controlled-radio-buttons-group">{i18n.t('weekends')}</FormLabel>
                                    <RadioGroup
                                        aria-labelledby="weekends-controlled-radio-buttons-group"
                                        name="controlled-radio-buttons-group"
                                        value={weekendValue}
                                        onChange={handleWeekendChange}
                                        >
                                        <FormControlLabel value="on24/7" control={<Radio />} label={i18n.t('on247')} />
                                        <FormControlLabel value="off" control={<Radio />} label={i18n.t('off')} />
                                        <FormControlLabel value="accumulation" control={<Radio />} label={`${i18n.t('onperschedule')}: ${i18n.t('accumulation')} — ${i18n.t('accumulationinfo')}`} />
                                        <FormControlLabel value="startStop" control={<Radio />} label={`${i18n.t('onperschedule')}: ${i18n.t('startstop')} — ${i18n.t('startstopinfo')}`} />
                                    </RadioGroup>
                                    </FormControl>
                                </Stack>
                                {weekendsOn && weekendScheduleOn &&(
                                    <>
                                    <Grid item container spacing={2} alignItems="center" sx={{ paddingTop: "10px", paddingBottom: "5px" }}>
                                        <Grid item>
                                        <Typography>{i18n.t('starttime')}:</Typography>
                                        </Grid>
                                        <Grid item>
                                        <TimePicker label={i18n.t('starttime')} value={weekendsStartTime} onChange={setWeekEndsStartTime} />
                                        </Grid>
                                    </Grid>

                                    <Grid item container spacing={2} alignItems="center">
                                        <Grid item>
                                        <Typography>{i18n.t('endtime')}:</Typography>
                                        </Grid>
                                        <Grid item style={{ paddingLeft: "21px", paddingBottom: "10px" }}>
                                        <TimePicker label={i18n.t('endtime')} value={weekendsEndTime} onChange={setWeekEndsEndTime} />
                                        </Grid>
                                    </Grid>
                                    </>
                                )}

                                <Dialog open={infoModalVisible} onClose={() => setInfoModalVisible(false)}>
                                    <DialogTitle>{i18n.t('todcontrolinfo')}</DialogTitle>
                                        <DialogContent>
                                            <Typography>
                                            {i18n.t('todcontrolinfotip')}<br /><br />
                        
                                            <strong>{i18n.t('off')}</strong>: {i18n.t('offinfo')}<br /><br />
                                            <strong>{i18n.t('on247')}</strong>: {i18n.t('on247info')}<br /><br />
                                            <strong>{i18n.t('onperschedule')}: {i18n.t('accumulation')}</strong>: {i18n.t('accumulationinfo')}<br /><br />
                                            <strong>{i18n.t('onperschedule')}: {i18n.t('startstop')}</strong>: {i18n.t('startstopinfo')}
                                            </Typography>
                                        </DialogContent>
                                    <DialogActions>
                                    <Button onClick={() => setInfoModalVisible(false)}>{i18n.t('close')}</Button>
                                    </DialogActions>
                                </Dialog>
                                </Grid>
                            </Paper>

                            <Grid item xs={12} style={{ paddingTop: "10px", paddingBottom: "10px" }}>
                                <Box display="flex" justifyContent="flex-end">
                                    <Button variant="contained" onClick={handleSave}>
                                        {loading
                                            ? <CircularProgress />
                                            : i18n.t('save')}
                                    </Button>
                                </Box>
                            </Grid>
                        </Container>
                    </LocalizationProvider>
                </Box>
            </Modal>
            <Snackbar open={snackbarOpen} autoHideDuration={3000} onClose={handleSnackbarClose}>
                <MuiAlert onClose={handleSnackbarClose} severity="success" sx={{ width: '100%' }}>
                    {i18n.t('notificationssettingssaved')}
                </MuiAlert>
            </Snackbar>
        </>
    );
}
